<template>
  <b-button
    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
    class="my-button"
    variant="outline-primary"
    @click="toggleViewMode"
  >
    <font-awesome-icon
      :icon="`${isGrid ? 'table' : 'table-cells'}`"
      size="lg"
    />
  </b-button>

</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import useMyStore from '@/services/useMyStore'
import { computed } from '@vue/composition-api'
import { BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    FontAwesomeIcon,
  },
  setup() {
    const { viewMode } = useMyStore()
    const isGrid = computed(() => viewMode.value === 'grid')

    return {
      viewMode,
      isGrid,
    }
  },
  methods: {
    toggleViewMode() {
      this.viewMode = this.isGrid ? 'table' : 'grid'
    },
  },
}
</script>

<style scoped>
</style>
